module.exports = __webpack_public_path__ + "static/img/border.054ee615.png";